<template>
    <div id="app">
        <router-view v-if="isPhone"/>
        <div v-if="!isPhone" style="margin-top:80px;text-align:center"> 
          
          <div style="font-size:18px;color:#323233;font-weight:bold;">振动盘打铁助手</div>
          <div style="margin-top:12px;color:#646566;">请使用微信扫码，直接使用小程序版</div>
          <div><img src="/mp-qrcode.jpg" style="width:240px;margin-top:16px;"></div>
          <div style="color:#969799;font-size:12px;margin-top:12px;">手机浏览器访问本页可继续使用 H5 版</div>
        </div>
    </div>
</template>

<script>
import BrowserInfo from '@/libs/Browserinfo';
export default {
    name: 'App',
    data() {
      return {
         isPhone : BrowserInfo.isPhone
      }
    },
    computed: {
      url() {
        return 'https://www.baidu.com'
      }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#footer {
  text-align: center;
}

</style>